/**
 * Devuelve el numero en string limpiado,
 * - sin espacios,
 * - sin lo ceros no revelante al principio y al final.
 *
 * Tiene que devolver lo mismo que `parseFloat(str)` cuando el numero es correcto.
 * Ojo que solo si correcto, justamente puede ser distinto si incorrecto:
 *  ej `${parseFloat('')}` => "NaN"
 *     trimNumber('') => '0'
 *
 * @param {string} str el numero a limpiar en formato string
 * @returns {string}
 */
export function trimNumber(str) {
  if (typeof str !== 'string') {
    throw new Error(`str must be a "string" and not "${typeof str}"`);
  }

  return trimStartNumber(trimEndNumber(str));
}

/**
 * Limpia los ceros al principio de un number.
 * No mira los decimales, despues del "." si existe.
 * Por eso, esta función es interna, porque suelte, devolvería un resultado "raro" en algunos casos
 * @param {string} str
 * @returns {string}
 */
function trimStartNumber(str) {
  let sign = '';
  let res = str;

  if (str.startsWith('-')) {
    // primero guardamos el signo '-' si esta
    sign = '-';
    // y lo quitamos de res para simplificar
    res = res.slice(1, res.length);
  }

  // quitamos todos los ceros de la izquierda
  res = res.replace(/^0*/, '');
  if (res === '.' || res === '') {
    // si la cadena resultante es vacia o es '.', el signo da igual, devolvemos 0
    return '0';
  }
  if (res.startsWith('.')) {
    // si la cadena resultante empieza por '.', ponemos el 0 delante
    return `${sign}0${res}`;
  }
  return `${sign}${res}`;
}

/**
 * Limpia los ceros no relevante a la derecha, despues del ".".
 * @param {string} str
 * @returns {string}
 */
function trimEndNumber(str) {
  if (!str.includes('.')) {
    return str.trim();
  }

  let res = str.trim();

  // clean finals '0' after "."
  while (res.endsWith('0')) {
    res = res.slice(0, -1);
  }

  // clean "." if it's the last char
  if (res.endsWith('.')) {
    return res.slice(0, res.length - 1);
  }

  return res;
}
